import { FunctionComponent, ReactElement, useContext } from 'react';
import styled from 'styled-components';
import { BaseButton } from '../../../components/DesignSystem';
import { store } from '../../../store/store';
import { ScoreProps } from '../../../utils/ResponsePageModel';
import DataCardForPaper from './DataCardForPaper';
import DataTable from './DataTable';
import Example from './Example';

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 40px;
  base-button {
    min-width: 286px;
  }
  //tablet or larger
  @media (min-width: 496px) {
    base-button {
      min-width: 195px;
    }
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  base-button {
    min-width: 286px;
  }
  //tablet or larger
  @media (min-width: 496px) {
    base-button {
      min-width: 275px;
    }
  }
`;

const TableContainer = styled.div`
  width: 100%;
  margin: 48px 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 6px #d3c5c5;
  base-card {
    border: 2px solid green;
  }
  @media (min-width: 496px) {
    flex-direction: row;
  }
`;
const FlexElement = styled.div`
  width: 100%;
  @media (min-width: 496px) {
    width: 50%;
  }
`;
// const TextContainer = styled.div`
//   position: relative;
//   margin-bottom: 30px;
// `;
// const Title = styled.div`
//   padding: 0px 35px;
//   font-size: 20px;
//   line-height: 28px;
//   color: #4a4a4a;
//   text-align: center;
//   font-weight: bold;
//   margin-bottom: 30px;
// `;
const GreenScoreDemat: FunctionComponent<ScoreProps> = ({ score }): ReactElement => {
  const {
    state: {},
    geoLoc,
  } = useContext(store);

  // const redirectToOnBoarding = () => {
  //   score?.redirectUrl ? window.location.replace(score?.redirectUrl) : '';
  // };
  const redirectToHomePage = () => {
    window.location.replace((window as unknown as WindowWithEnv)._env_.cetelemUrl);
  };
  return (
    <>
      <Container>
        {window.screen.availWidth < 496 && (
          <ButtonContainer>
            <BaseButton onClick={redirectToHomePage}>Retourner à l'accueil</BaseButton>
          </ButtonContainer>
        )}
        {geoLoc === 'CTLM' && (
          <>
            <TableContainer>
              <FlexElement>
                <DataTable score={score} />
              </FlexElement>
              <FlexElement>
                {' '}
                <Example score={score} />
              </FlexElement>
            </TableContainer>
          </>
        )}
        <DataCardForPaper />
        {window.screen.availWidth > 496 && (
          <ButtonContainer>
            <BaseButton onClick={redirectToHomePage}>Retourner à l'accueil</BaseButton>
          </ButtonContainer>
        )}
      </Container>
    </>
  );
};

export default GreenScoreDemat;
